import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedAltUsername = mutatorAction('updateAdvancedAltUsername', function (username) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.altUsername = username;
});
//# sourceMappingURL=updateAdvancedAltUsername.js.map